import { Modal, App } from 'antd';
import React from 'react'
import { useGoodsGuigeDelMutation } from '../../store/ReactWebSiteApi';

function GoodsSpecDel(props) {
    const { message } = App.useApp();
    const {confirm} = Modal; 
    const [delBusiness] = useGoodsGuigeDelMutation()
    return (
        <a onClick={() => {
            confirm({
                title: '确定删除吗？',
                content: props.egg_name,
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    delBusiness({egg_id:props.egg_id}).then((res) => {
                        if (res.data.Status === 'success') {
                            message.info('删除成功！');
                        }
                        if (res.data.Status === "fail") {
                            message.error('删除失败！'+res.data.Message)
                        }
                    })
                },
                onCancel() {
                console.log('Cancel');
                },
            });
        }}>删除</a>
    )
}

export default GoodsSpecDel